module.exports = __webpack_public_path__ + "static/img/labourservices-2.98cfce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labourservices-2.png
// module id = AOON
// module chunks = 1